import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import ErrorMessage from 'apis/ErrorMessage';
import { clientApi } from 'apis/package/packageApis';

/// 클라이언트 목록
export const useClientList = (package_id: string) => {
  const { status, data, error, isFetching } = useQuery(
    ['clientList', package_id],
    async () => await clientApi.read(package_id),
    {
      select: (data) => {
        // console.log(data);
        const newArr: any = [];

        data?.forEach((v, i) => {
          if (v.client_status === 'test') {
            newArr.push({ ...v, color: `#EED14C`, client_status_KO: '테스트' });
          }
          if (v.client_status === 'review') {
            newArr.push({ ...v, color: `#fb8f37`, client_status_KO: '심사' });
          }
          if (v.client_status === 'beta') {
            newArr.push({
              ...v,
              color: `#88c637`,
              client_status_KO: '베타 서비스',
            });
          }
          if (v.client_status === 'live') {
            newArr.push({
              ...v,
              color: `#2ab1a6`,
              client_status_KO: '라이브 서비스',
            });
          }
          if (v.client_status === 'update') {
            newArr.push({
              ...v,
              color: `#b7b7b7`,
              client_status_KO: '업데이트 필수',
            });
          }
          if (v.client_status === 'close') {
            newArr.push({ ...v, color: `#7c7c7c`, client_status_KO: '종료' });
          }
        });
        return newArr;
      },
    },
  );
  return { status, data, error, isFetching };
};

/// 등록
export const useClientRegister = (setVisible) => {
  const queryClient = useQueryClient();
  return useMutation(async (props: any) => await clientApi.register(props), {
    onMutate: (props) => {
      ('');
    },
    onSuccess: (data) => {
      console.log(data);
      setVisible(false);
      queryClient.invalidateQueries(['clientList']);
      message.success('클라이언트가 등록되었습니다', 1);
    },
    onError: (props) => (err: any, variables, context) => {
      if (err?.response) {
        ErrorMessage(err.response.status, err.response.data);
      }
    },
  });
};

/// 수정
export const useClientUpdate = (setInputMode, setVisible) => {
  const queryClient = useQueryClient();
  return useMutation(async (props: any) => await clientApi.update(props), {
    onMutate: (props) => {
      ('');
    },
    onSuccess: (data) => {
      setInputMode(false);
      setVisible(false);
      queryClient.invalidateQueries(['clientList']);
      message.success('클라이언트가 수정되었습니다', 1);
    },
    onError: (props) => (err: any, variables, context) => {
      if (err?.response) {
        ErrorMessage(err.response.status, err.response.data);
      }
    },
  });
};

/// 삭제
export const useClientDelete = (setVisible) => {
  const queryClient = useQueryClient();
  return useMutation(async (props: any) => await clientApi.delete(props), {
    onMutate: (props) => {
      //   console.log('onMutate', props);
    },
    onSuccess: (data) => {
      setVisible(false);
      queryClient.invalidateQueries(['clientList']);
      message.success('현재 버전의 클라이언트가 삭제되었습니다', 1);
    },
    onError: (err: any) => {
      if (err.response) {
        ErrorMessage(err.response.status, err.response.data);
        return;
      }
    },
  });
};
